import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQueryClient } from '@tanstack/react-query';

import type { BookingcomRoomsList } from 'app/typings/core/extranet/inventory/autoInventory';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '..';

export function useAutoInventoryRooms() {
  const queryClient = useQueryClient();

  const getAutoInventoryRooms = (hotelId: number) => {
    return queryClient.fetchQuery<
      BookingcomRoomsList[],
      unknown,
      BookingcomRoomsList[],
      (typeof CORE_QUERY_KEYS.autoInventoryRooms | { hotelId: number })[]
    >({
      queryKey: [CORE_QUERY_KEYS.autoInventoryRooms, { hotelId }],
      queryFn: () =>
        apiRequest({
          path: ENDPOINTS.getAutoInventoryRooms,
          params: { hotelId: hotelId.toString() },
        }),
      staleTime: 5 * MILLISECONDS_IN_MINUTE,
    });
  };

  return {
    getAutoInventoryRooms,
  };
}
